import { render, staticRenderFns } from "./CustomerLabs.vue?vue&type=template&id=51ac048f&scoped=true&"
import script from "./CustomerLabs.vue?vue&type=script&lang=ts&"
export * from "./CustomerLabs.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerLabs.vue?vue&type=style&index=0&id=51ac048f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac048f",
  null
  
)

export default component.exports